import React, { createContext, useState, useEffect, useContext } from "react"
import ServicesTableTitle from "../../constants/ServicesTableTitle.json"
import API from "../../api/api"
import TestuserData from "../../test/userList.json"
import { store } from "./../../context/store"
import { db } from "../../helpers/firebase_helper"
import { SERVICE_LIST } from "../../context/types"

export const ServicesContext = createContext()

export const ServicesContextProvider = ({ children }) => {
  const globalState = useContext(store)
  const { state } = globalState
  const { dispatch } = globalState
  const [servicesData, setAdminData] = useState([])

  console.log("Store state data______________________________", state)
  const getServiceList = async () => {
    // API.getServicesList()
    //   .then(response => {
    //     setAdminData(response.data.data)
    //   })
    //   .catch(e => {})
    let serviceList = []
    const snapshot = await db.collection("services").get()
    await snapshot.forEach(async doc => {
      const snapshotDashboard = await db
        .collection("services")
        .doc(doc.id)
        .get()

      const userDoc = { ...snapshotDashboard.data(), id: doc.id }
      console.log("_________Each for each result_______", userDoc)
      serviceList.push(userDoc)
      dispatch({ type: SERVICE_LIST, payload: serviceList })
      setAdminData(serviceList)
    })
  }

  useEffect(() => {
    getServiceList()
  }, [])

  const providerValue = {
    servicesData,
    ServicesTableTitle,
    getServiceList,
  }

  return (
    <ServicesContext.Provider value={providerValue}>
      {children}
    </ServicesContext.Provider>
  )
}
